"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.copilotPluginOptionIds = exports.copilotPluginNewApiOptionId = exports.copilotPluginExistingApiOptionIds = exports.copilotPluginOpenAIPluginOptionId = exports.copilotPluginApiSpecOptionId = void 0;
exports.copilotPluginApiSpecOptionId = "copilot-plugin-existing-api";
exports.copilotPluginOpenAIPluginOptionId = "copilot-plugin-openai-plugin";
exports.copilotPluginExistingApiOptionIds = [
    exports.copilotPluginApiSpecOptionId,
    exports.copilotPluginOpenAIPluginOptionId,
];
exports.copilotPluginNewApiOptionId = "copilot-plugin-new-api";
exports.copilotPluginOptionIds = [
    exports.copilotPluginNewApiOptionId,
    exports.copilotPluginApiSpecOptionId,
    exports.copilotPluginOpenAIPluginOptionId,
];
//# sourceMappingURL=constants.js.map